/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const EqualRevision: core.serialization.ObjectSchema<serializers.EqualRevision.Raw, Truvity.EqualRevision> =
    core.serialization.object({
        value: core.serialization.number(),
    });

export declare namespace EqualRevision {
    export interface Raw {
        value: number;
    }
}
